import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("btp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("btp_token");
      localStorage.removeItem("btp_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const ROLE_LABELS = {
  super_admin: "Super Administrateur",
  admin: "Administrateur",
  chef_projet: "Chef de projet",
  expert: "Expert",
  client: "Client",
};

export const STATUS_LABELS = {
  brouillon: "Brouillon",
  en_revision: "En révision",
  corrige: "Corrigé",
  valide: "Validé",
  approuve: "Approuvé",
  archive: "Archivé",
  opportunite: "Opportunité",
  proposition: "Proposition",
  contrat: "Contrat",
  en_cours: "En cours",
  livre: "Livré",
};

export const PROJECT_STATUSES = ["opportunite", "proposition", "contrat", "en_cours", "livre", "archive"];
export const TASK_STATUSES = ["brouillon", "en_revision", "corrige", "valide", "approuve", "archive"];

export function fmtMoney(value) {
  const n = Number(value || 0);
  return "$ " + new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(n);
}

export function fmtDate(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return value; }
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]?.toUpperCase()).join("");
}
